module.exports = __webpack_public_path__ + "static/media/image (14).2d7abd39.jpg";